import React from 'react';
import { LazyImage } from 'react-lazy-images';
import Loader from '@components/shared/Loader/Loader';
import PlaceholderImage from '@components/shared/images/atoms/Image/PlaceholderImage';

export interface ImageProps {
  /** The source of the image to load */
  src: string;

  /** The source set of the image to load */
  srcSet?: string;

  /** The alt text description of the image you are loading */
  alt?: string;

  /** Sizes descriptor */
  sizes?: string;
}

interface IDeferredImageProps {
  imgProps: ImageProps;
  className?: string;
  loadEagerly?: boolean;
  showLoadingAnimation?: boolean;
}

const DeferredImage = ({
  imgProps,
  className = '',
  loadEagerly = false,
  showLoadingAnimation = true,
}: IDeferredImageProps) => (
  <LazyImage
    {...imgProps}
    actual={({ imageProps }) => (
      <img
        {...imageProps}
        className={className}
        alt={imageProps.alt}
        loading={loadEagerly ? 'eager' : 'lazy'}
      />
    )}
    loading={() => (showLoadingAnimation ? <Loader /> : <></>)}
    placeholder={
        ({ imageProps, ref }) => (
          <PlaceholderImage {...imageProps} className={className} ref={ref} />
        )
      }
  />
);

export default DeferredImage;
